import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';
import { Button } from '@material-ui/core';
import {
  ColorPalette,
} from 'screens/addEditCustomScreen/widgetsCardData/horizontalWidgetCard/types';
import { useLocation } from 'react-router';

const TabWidget: React.FC<WidgetProps> = (props: WidgetProps) => {

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  
  const paramLang = queryParams.get('lang');
  
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  return (
    <div
      className={classNames([styles.TabCard])}
      style={defaultPaddings}
    >
      <div className={styles.TabCardHeader}>
        <img
          src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
          className={classNames([styles.widgetImage])}
        />
        {
          String(widgetParams.showTextImage) === 'true' ?
          <img className={classNames([styles.textImage])} src={widgetParams.textImage}/>:
          <p
            className={classNames([styles.widgetTitle])}
          >
            {widgetParams.subTitle}
          </p>
        }
      </div>
      <div className={classNames([`${widgetParams.isImageArrow}` === 'false' ? styles.hide : null ])}>
        <img className={classNames([styles.imageArrow , paramLang === 'en' ? styles.rotate180Deg : null])} src={images.arrow}/>
      </div>
    </div>
  );
};

export default TabWidget;
